import React from 'react';

import { cn } from '~/lib/utils';

interface FilterBarSkeletonProps {
  className?: string;
}

function FilterChipSkeleton({ className }: FilterBarSkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn(
        'h-8 rounded border border-gray-200 bg-gray-100 animate-pulse',
        className
      )}
    />
  );
}

export function ProductFiltersSkeleton() {
  return (
    <>
      <FilterChipSkeleton className="w-[88px]" />
      <FilterChipSkeleton className="w-[96px]" />
    </>
  );
}

export function FilterDropdownSkeleton() {
  return <FilterChipSkeleton className="w-[88px]" />;
}
